import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepperData = ["内容入力", "機構へ提出"];

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "延長の対象となる掛金（年度）",
    keyword: "premiumsForExtensio",
    type: "text",
  },
  {
    title: "延長の対象となる掛金（金額）",
    keyword: "premiumsForExtensioAmount",
    type: "text",
  },
  {
    title: "希望する延長期限日付",
    keyword: "applyDate",
    type: "date",
    disabled: true,
    requiredIcon: true,
    helpicon: true,
    helpText: "希望する延長期限日付を入力してください。",
  },
  {
    title: "延長前の納付期限",
    keyword: "deadlineBeforeExtension",
    type: "text",
  },
  {
    title: `延長申請理由※具体的に記入`,
    keyword: "reasons",
    type: "textarea",
    disabled: true,
    requiredIcon: true,
    helpicon: true,
    helpText: "延長申請理由を具体的に記載してください。",
  },
  {
    title: "延長申請の理由証明書",
    keyword: "downloadLink1",
    type: "downloadLink",
    base64filedata: "",
    downloadBase64: true,
    dataname: "延長申請の理由証明書",
    showLine: false,
  },
  {
    title: "備考",
    keyword: "remark",
    type: "textarea",
    disabled: true,
    helpicon: true,
    helpText: "備考があればご入力ください。",
  },
];

const headList: any = [
  {
    headTitle: "帳票名",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
  {
    headTitle: "決裁日",
    align: "left",
  },
];

const schema = {
  applyDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  reasons: {
    minLength: {
      value: 0,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  remark: {
    minLength: {
      value: 0,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
};

export { schema, stepperData, fakeTableList, headList };
